import { cn } from "@/lib/cn";

import celebratePng from "./pose-celebrate.png";
import excitedPng from "./pose-excited.png";
import idlePng from "./pose-idle.png";
import thinkPng from "./pose-think.png";
import wavePng from "./pose-wave.png";

export type Pose = "idle" | "wave" | "excited" | "celebrate" | "think";

const art: Record<Pose, string> = {
  idle: idlePng,
  wave: wavePng,
  excited: excitedPng,
  celebrate: celebratePng,
  think: thinkPng,
};

const poses = Object.keys(art) as Pose[];

/**
 * Heidi from the head down to a little torso, for the two places she is
 * talking: the tour's board and the field guide's bubble. The five drawings
 * share one canvas (920×456 with her face centred on x=468 and the top of
 * her head on the top edge, all at the same scale), so a pose change never
 * moves her head; only the arms and ears move. The lower body is cut off at
 * the canvas and is meant to sit behind the thing she leans on.
 *
 * All five are in the DOM at once and the others sit at zero opacity: a
 * swapped `src` decodes on first use, and a line that arrives with her
 * missing for a frame reads as a glitch.
 */
export function MascotPose({ pose = "idle", className }: { pose?: Pose; className?: string }) {
  return (
    <span className={cn("mascot-pose", className)} data-pose={pose} aria-hidden>
      {poses.map((name) => (
        <img
          key={name}
          className={cn("mascot-pose-img", name === pose && "is-on")}
          data-pose={name}
          src={art[name]}
          alt=""
          draggable={false}
        />
      ))}
    </span>
  );
}
